import { Component, input } from '@angular/core';

@Component({
  selector: 'app-transport-stop-details',
  standalone: true,
  imports: [
    
  ],
  templateUrl: './transport-stop-details.component.html',
  styleUrls: ['./transport-stop-details.component.scss'],
})
export class TransportStopDetailsComponent {
  public stopDetails = input<string>();
}
